import React from 'react'
import { ImageBlock } from './image-block'
import { Chip } from './chip'
import { Avatar, AvatarGroup } from '@mui/material';

export function NameBar({ name, image, color, backgroundColor }): JSX.Element {
  return (
    <Chip
      label={name}
      avatar={<ImageBlock image={image} backgroundColor={backgroundColor} />}
      sx={{ color, backgroundColor, width: '100%' }}
    />
  )
}

export function NameBarStack({ collection = [] }) {
  if (!collection.length) {
    return null
  }
  return (
    <>
      {collection.map(item => (
        <NameBar key={item.id} {...item} />
      ))}
    </>
  )
}

export function AvatarStack({ collection = [], max = 5, width = 70, height = 70 }) {
  if (!collection.length) {
    return null
  }
  return (
    <AvatarGroup max={max}>
      {collection.map(item => (
        <Avatar key={item?.id} alt={item?.name} title={item?.name}  src={item?.image} sx={{ width, height }} />
      ))}
    </AvatarGroup>
  )
}
